import { gql } from '@apollo/client'

export const GET_ALL_APP_USER_PAGINATION = gql`
  query GetAllAppUsersPagination(
    $searchQuery: String
    $limit: Int
    $offset: Int
  ) {
    getAllAppUsersPagination(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
    ) {
      rows {
        id
        name
        username
        role_id
        AppUserRole {
          id
          name
        }
      }
      count
    }
  }
`

export const GET_APP_USER_BY_ID = gql`
  query GetAppUserById($id: Int!) {
    getAppUserById(id: $id) {
      id
      name
      username
      role_id
    }
  }
`

export const DELETE_APP_USER = gql`
  mutation DeleteAppUser($id: Int!) {
    deleteAppUser(id: $id)
  }
`

export const CREATE_APP_USER = gql`
  mutation CreateAppUser(
    $name: String!
    $username: String!
    $password: String!
    $role_id: Int!
  ) {
    createAppUser(
      name: $name
      username: $username
      password: $password
      role_id: $role_id
    )
  }
`

export const UPDATE_APP_USER = gql`
  mutation UpdateAppUser(
    $id: Int!
    $name: String!
    $username: String!
    $password: String
    $role_id: Int!
  ) {
    updateAppUser(
      id: $id
      name: $name
      username: $username
      password: $password
      role_id: $role_id
    )
  }
`
